import React from 'react'
import Routes from 'routes'
import { Card } from 'components/library'
import { getItemById } from 'helpers'
import { translate } from 'translations'
import './NavigationCards.css'

class NavigationCards extends React.Component {
  state = {
    pos: 0,
    isMobile: false,
    willAnimate: false,
  }

  touchStartX = 0
  touchMove = 0
  containerWidth = (this.props.navigation.length * (360 + 40)) - window.innerWidth + 40
  speed = 3
  distance = 100

  get isMobile() {
    return /Mobi|Tablet|iPad|iPhone/.test(navigator.userAgent)
  }

  componentDidMount() {
    this.detectMobile()
    if(this.isMobile) this.willAnimate()
    window.addEventListener('resize', this.handleResize, false)
  }

  componentWillUnmount() {
    clearTimeout(this.t1)
    clearTimeout(this.t2)
    window.removeEventListener('resize', this.handleResize, false)
  }

  willAnimate() {
    const pos = this.props.translateTo ? Math.max(0, Math.min((this.props.translateTo.id-1) * (360 + 40), this.containerWidth)) : 0
    this.t1 = setTimeout(() => {
      this.touchMove = pos
      this.refs['container'].style.transform = `translateX(-${this.touchMove}px)`
      this.setState(prevState => ({
        willAnimate: true
      }), () => {
        this.touchStartX = pos

        this.t2 = setTimeout(() => {
          this.setState({ willAnimate: false })
        }, 600)
      })
    }, 200)
  }

  handleResize = e => {
    this.detectMobile()

    if(!this.state.isMobile) {
      this.containerWidth = (this.props.navigation.length * (360 + 40)) - window.innerWidth + 40
      this.touchStartX = 0
    }
  }

  detectMobile = () => {
    this.setState({ isMobile: this.isMobile })

    if(!this.isMobile) {
      this.refs['container'].style.transform = `translateX(0)`
    }
  }

  handleTouchStart = e => {
    this.lastTouch = this.touchMove
    this.touchStartX = this.touchStartX + e.targetTouches[0].clientX
  }

  handleTouchMove = e => {
    const pos = this.touchStartX - e.targetTouches[0].clientX
    this.touchMove = Math.max(0, Math.min(pos, this.containerWidth))

    //this.setState({ pos: this.touchMove })
    this.refs['container'].style.transform = `translateX(-${this.touchMove}px)`
  }

  handleTouchEnd = e => {
    this.touchStartX = this.touchMove

    this.distance = this.lastTouch > this.touchMove ? 50 : -50
    //window.requestAnimationFrame(this.updateAnimation)
  }

  updateAnimation = () => {
    if(this.distance > 0) {
      this.distance -= this.speed
      const current = this.state.pos + this.distance
      console.log(current)
      this.setState({ pos: current })
      window.requestAnimationFrame(this.updateAnimation)
    }
  }

  render() {
    return (
      <div className={`Navigation-cards${this.state.isMobile ? ' is-mobile' : ''}`}
        onTouchStart={this.handleTouchStart}
        onTouchMove={this.handleTouchMove}
        onTouchEnd={this.handleTouchEnd}>

        <div className={`Navigation-cards-container${this.state.willAnimate ? ' has-animation' : ''}`} ref="container">
          {this.props.navigation.map((item, idx) => {
            switch(item.type) {
              case "page":
                return <PageMenuCard key={idx} {...item}
                  ref={el => this.props.setElms(idx, el)}
                  progress={getItemById(this.props.lastProgress, item.id)}
                  page={getItemById(this.props.pages, item.pageId)} />

              case "chapter":
                return <ChapterMenuCard key={idx} {...item}
                  ref={el => this.props.setElms(idx, el)}
                  progress={getItemById(this.props.lastProgress, item.id)}
                  chapter={getItemById(this.props.chapters, item.chapterId)} />

              case "endtest":
                return <EndtestMenuCard key={idx} {...item}
                  ref={el => this.props.setElms(idx, el)}
                  progress={getItemById(this.props.lastProgress, item.id)} />

              default:
                return false
            }
          })}
        </div>
      </div>
    )
  }
}

class PageMenuCard extends React.Component {
  render() {
    return (
      <div className={`Navigation-cards-item has-theme-${this.props.theme || 'default'}`}>
        <Card
          title={this.props.page.title}
          progress={this.props.progress.progress}
          total={this.props.progress.total}
          status={this.props.progress.status}
          label={this.props.page.label}
          icon={this.props.page.icon}
          static={this.props.page.static}
          to={Routes.to('page', { page: this.props.page.slug })} />
      </div>
    )
  }
}

class ChapterMenuCard extends React.Component {
  render() {
    return (
      <div className={`Navigation-cards-item has-theme-${this.props.theme || 'default'}`}>
        <Card
          title={this.props.chapter.title}
          progress={this.props.progress.progress}
          total={this.props.progress.total}
          status={this.props.progress.status}
          to={this.props.progress.progress > 0 && this.props.progress.progress <= this.props.progress.total
            ? Routes.to('aspect', { chapter: this.props.chapter.slug, aspect: +this.props.progress.progress+1 })
            : Routes.to('chapter', { chapter: this.props.chapter.slug })} />
      </div>
    )
  }
}

class EndtestMenuCard extends React.Component {
  render() {
    return (
      <div className={`Navigation-cards-item has-theme-${this.props.theme || 'default'}`}>
        <Card
          title={translate('endtest.title')}
          progress={this.props.progress.progress}
          total={this.props.progress.total}
          status={this.props.progress.status}
          to={Routes.to(this.props.progress.status === 'notpassed' ? 'endtestTest' : 'endtest')} />
      </div>
    )
  }
}

export default NavigationCards



// WEBPACK FOOTER //
// ./src/components/views/home/components/NavigationCards.js